import management from './management';
import quality from './quality';

export default {
    management,
    quality,
};
